export default {
  id: null,
  nome: null,
  tipoAcessoOrigem: []
}



// WEBPACK FOOTER //
// ./src/shared/models/configurations/originmodel.js